module.exports = __webpack_public_path__ + "img/318-4177ac.png";